export default __webpack_public_path__ + "static/media/UNMISS_integrated_search_operation_for_weapons.c98030be.jpg";